<template>
  <div class="container-fluid">
    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary"
        data-toggle="modal"
        data-target="#blockModal"
        @click="blockModal({ action: 'add' })"
      >
        {{ i18n("Buttons.Add") }}
      </button>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="sort" slot-scope="scope">
          <div class="text-center">
            <button
              v-if="scope.row.id !== 1"
              type="button"
              class="btn btn btn-outline-secondary btn-sm"
              @click="changeSort(scope.row.Guid, 'up')"
            >
              <i class="fas fa-long-arrow-alt-up" />
            </button>
            <button
              v-if="scope.row.id !== rows.length"
              type="button"
              class="btn btn-outline-secondary btn-sm"
              @click="changeSort(scope.row.Guid, 'down')"
            >
              <i class="fas fa-long-arrow-alt-down" />
            </button>
          </div>
        </template>
        <template slot="edit" slot-scope="scope">
          <button
            type="button"
            class="btn btn-info btn-sm"
            style="margin-right: 0.5rem"
            data-toggle="modal"
            data-target="#blockModal"
            @click="blockModal({ action: 'edit', data: scope.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>

        <template slot="delete" slot-scope="scope">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delBlockModal"
            @click="block = scope.row"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      class="modal fade"
      id="blockModal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-lg"
      >
        <ValidationObserver
          ref="block"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-content">
              <div class="modal-header">
                <span class="modal-title">
                  <span v-if="action === 'add'">新增</span>
                  <span v-else>編輯</span>
                </span>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for="select-block-type">
                      <span class="mark">*</span>
                      類型
                    </label>
                    <select
                      id="select-block-type"
                      class="form-control"
                      v-model="block.Position"
                    >
                      <option value="無">僅文字</option>
                      <option value="左">有圖片(左側)</option>
                      <option value="右">有圖片(右側)</option>
                    </select>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for="input-block-title">
                      <span class="mark">*</span>
                      標題
                    </label>
                    <input
                      type="text"
                      id="input-block-title"
                      class="form-control"
                      maxlength="50"
                      v-model="block.Title"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for="input-block-content">
                      <span class="mark">*</span>
                      內容
                    </label>
                    <textarea
                      id="input-block-content"
                      class="form-control"
                      rows="18"
                      maxlength="4000"
                      v-model="block.Content"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>

                <div
                  v-if="block.Position === '左' || block.Position === '右'"
                  class="form-group"
                >
                  <label for=""><span class="mark">*</span>圖片</label>
                  <img
                    v-if="blockPic"
                    class="form-control"
                    style="height: 360px; margin-bottom: 10px"
                    :src="blockPic"
                    alt=""
                  />
                  <div style="margin-bottom: 10px">
                    <span class="mark">* 檔案限制：[檔名].jpg、[檔名].png</span
                    ><br />
                    <span class="mark">* 大小限制：5MB以下</span><br />
                    <span class="mark">* 僅能選取一個檔案</span><br />
                    <span class="mark">* 上傳前請確認是否符合格式</span>
                  </div>
                  <ValidationProvider
                    ref="Pic"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <el-upload
                      ref="uploadPic"
                      class="upload-demo"
                      action=""
                      accept="image/jpeg,image/png"
                      :limit="1"
                      :auto-upload="false"
                      list-type="picture"
                      :on-change="uploadFile"
                      :on-remove="removeFile"
                      v-model="block.Pic"
                    >
                      <el-button size="small" type="primary">
                        點擊上傳
                      </el-button>
                    </el-upload>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="block.Pic ? $refs.uploadPic.clearFiles() : null"
                >
                  {{ i18n("Buttons.Cancel") }}
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(saveBlock)"
                >
                  {{ i18n("Buttons.Save") }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      id="delBlockModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">刪除</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ block.Title }}</span
            >
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delBlock"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "Block",

  data() {
    return {
      // 判斷新增、編輯
      action: "add",
      block: {},

      blockPic: null,

      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "",
          name: "sort",
        },
        {
          label: "標題",
          name: "Title",
        },
        {
          label: "",
          name: "edit",
          slot_name: "edit",
        },
        {
          label: "",
          name: "delete",
          slot_name: "delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  watch: {
    "block.Position": function (e) {
      if (e === "無") {
        this.block.Pic = "";
      }
    },
  },

  methods: {
    // 分頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getBlock();
    },

    // 取得 區塊
    getBlock() {
      this.updateLoading(true);
      this.$api.frontPage
        .getCompanyProfilePaging({
          startDate: null,
          endDate: null,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.totalData = response.data.Quantity;
            this.rows = response.data.Datas.map((item, index) => {
              return {
                id: ++index,
                ...item,
              };
            });
          }
          this.updateLoading(false);
        });
    },

    // 上傳 檔案
    uploadFile(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isLt5M) {
        this.$notify({
          title: "失敗",
          message: "圖片大小不得超過5MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        // 圖片的 base64
        this.block.Pic = e.target.result;
        this.$refs.Pic.reset();
      };
    },

    // 移除 檔案
    removeFile() {
      this.block.Pic = null;
      this.$refs.Pic.syncValue();
    },

    // 區塊 Modal
    blockModal({ action, data }) {
      switch (action) {
        case "add":
          this.block = {};
          this.action = "add";
          break;
        case "edit":
          this.block = {
            Pic: data.Pic,
            Position: data.Position,
            Title: data.Title,
            Content: data.Content,
            Guid: data.Guid,
          };
          this.blockPic = data.Pic;
          this.action = "edit";
          break;
      }
      this.$refs.block.reset();
    },

    // 新增、編輯 區塊
    saveBlock() {
      $("#blockModal").modal("hide");
      this.updateLoading(true);
      let message;
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.frontPage
            .postBlock({
              ...this.block,
              CreateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getBlock();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.frontPage
            .putBlock({
              ...this.block,
              UpdateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getBlock();
              }
              this.updateLoading(false);
            });
          break;
      }
      if (this.block.Pic) {
        this.$refs.uploadPic.clearFiles();
      }
    },

    // 刪除 區塊
    delBlock() {
      this.updateLoading(true);
      this.$api.frontPage
        .deleteCompanyProfile(this.block.Guid)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getBlock();
          }
          this.updateLoading(false);
        });
    },

    // 變更 區塊排序
    changeSort(guid, status) {
      this.updateLoading(true);
      this.$api.frontPage
        .sortCompanyProfile({
          ProfileGuid: guid,
          Turn: status,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "排序變更成功",
              type: "success",
              duration: 2000,
            });
            this.getBlock();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.$set(this.block, "Position", null);
  },
};
</script>
